import { JupasProgram } from "../types";

const getUni = (code: string) => {
    const c = String(code);
    if (c.startsWith('1')) return 'CityU';
    if (c.startsWith('2')) return 'HKBU';
    if (c.startsWith('3')) return 'PolyU';
    if (c.startsWith('4')) return 'CUHK';
    if (c.startsWith('5')) return 'HKUST';
    if (c.startsWith('6')) return 'HKU';
    if (c.startsWith('7')) return 'Lingnan';
    if (c.startsWith('8')) return 'EdUHK';
    if (c.startsWith('9')) return 'HKMU';
    if (c.startsWith('S')) return 'SSSDP';
    return 'Other';
};

export const UNIV_RANGES = {
    'All': '0',
    'CityU': '1',
    'HKBU': '2',
    'PolyU': '3',
    'CUHK': '4',
    'HKUST': '5',
    'HKU': '6',
    'Lingnan': '7',
    'EdUHK': '8',
    'HKMU': '9',
    'SSSDP': 'S'
};

// HKUST
// Extended Modules M1; Extended Modules M2
// Biology; Combined Science (Bio + Chem); Combined Science (Bio + Phy)
// Chemistry; Combined Science (Bio + Chem); Combined Science (Chem + Phy)
// Physics; Combined Science (Bio + Phy); Combined Science (Chem + Phy)

// HKBU, HKMU:
// Extended Modules M1; Extended Modules M2
// Biology; Integrated Science; Combined Science (Bio + Chem); Combined Science (Bio + Phy)
// Chemistry; Integrated Science; Combined Science (Bio + Chem); Combined Science (Chem + Phy)
// Physics; Integrated Science; Combined Science (Bio + Phy); Combined Science (Chem + Phy)

// const FORBIDDEN_GROUPS_STANDARD = [
//     ["Mathematics Extended Part Module 1", "Mathematics Extended Part Module 2"],
//     ["Integrated Science", "Combined Science"],
//     ["Biology", "Combined Science"],
//     ["Chemistry", "Combined Science"],
//     ["Physics", "Combined Science"]
// ];

// Extended Modules M1; Extended Modules M2
// Biology; Integrated Science; Combined Science (Bio + Chem); Combined Science (Bio + Phy)
// Chemistry; Integrated Science; Combined Science (Bio + Chem); Combined Science (Chem + Phy)
// Physics; Integrated Science; Combined Science (Bio + Phy); Combined Science (Chem + Phy)

// https://www.polyu.edu.hk/study/ug/admissions/jupas/jupas-admission-selection
// 1. Extended Modules M1; Extended Modules M2
// 2. Biology; Integrated Science; Combined Science (Bio + Chem); Combined Science (Bio + Phy)
// 3. Chemistry; Integrated Science; Combined Science (Bio + Chem); Combined Science (Chem + Phy)
// 4. Physics; Integrated Science; Combined Science (Bio + Phy); Combined Science (Chem + Phy)
// 5. Business, Accounting and Financial Studies; Business, Accounting and Financial Studies (Accounting); Business, Accounting and Financial Studies (Business Mgt)
// 6. Technology and Living (Food Science and Technology); Technology and Living (Fashion, Clothing and Textiles)

// const FORBIDDEN_GROUPS_POLYU = [
//     ["Mathematics Extended Part Module 1", "Mathematics Extended Part Module 2"],
//     ["Biology", "Integrated Science", "Combined Science (Biology, Chemistry)", "Combined Science (Biology, Physics)"],
//     ["Chemistry", "Integrated Science", "Combined Science (Biology, Chemistry)", "Combined Science (Physics, Chemistry)"],
//     ["Physics", "Integrated Science", "Combined Science (Biology, Physics)", "Combined Science (Physics, Chemistry)"],
//     ["Business, Accounting and Financial Studies", "Business, Accounting and Financial Studies (Accounting)", "Business, Accounting and Financial Studies (Business Management)"],
//     ["Technology and Living (Food Science and Technology)", "Technology and Living (Fashion, Clothing and Textiles)"]
// ];

// import institutionsRaw from '../../../data/institutions.json';
// import programmesRaw from '../../../data/programmes.json';

// Transform function to convert JSON structure to expected format
// function transformProgramme(prog: any): JupasProgram {
//     // Parse elective_minima to extract count and min_level
//     let electivesCount = 2; // default
//     let electivesMinLevel = 2; // default
//     let oneOfElectives: any = undefined;
//     let oneOfGroups: any = undefined;
    
//     if (prog.program_mer?.elective_minima) {
//         const electives = prog.program_mer.elective_minima;
//         const keys = Object.keys(electives);
        
//         // Process each elective requirement
//         for (const key of keys) {
//             const electiveReq = electives[key];
//             const subjectKeys = Object.keys(electiveReq);
            
//             if (subjectKeys.length > 0) {
//                 const requirement = subjectKeys[0];
//                 const minLevel = electiveReq[requirement];
                
//                 // Check if it's a "one_of" requirement
//                 if (key.includes('one_of')) {
//                     // Extract subjects and their minimum levels
//                     const subjects = Object.keys(electiveReq);
//                     const levels = Object.values(electiveReq) as number[];
//                     const commonMinLevel = levels.length > 0 ? Math.min(...levels) : 2;
                    
//                     if (!oneOfElectives) {
//                         oneOfElectives = {
//                             subjects: subjects,
//                             min_level: commonMinLevel
//                         };
//                     }
//                 } else {
//                     // Regular "ANY X SUBJECTS" requirement
//                     const match = requirement.match(/(\d+)\s+SUBJECT/i);
//                     if (match) {
//                         electivesCount = parseInt(match[1]);
//                     }
//                     electivesMinLevel = typeof minLevel === 'number' ? minLevel : 2;
//                 }
//             }
//         }
//     }
    
//     const transformedMER: any = {
//         ...prog.program_mer,
//         electives: {
//             count: electivesCount,
//             min_level: electivesMinLevel,
//             include_cores: false
//         }
//     };
    
//     // Add one_of_electives if present
//     if (oneOfElectives) {
//         transformedMER.one_of_electives = oneOfElectives;
//     }
    
//     return {
//         ...prog,
//         program_mer: transformedMER
//     } as JupasProgram;
// }
// export const INSTITUTIONS_DATA = institutionsRaw;
// export const PROGRAMMES_DATA = (programmesRaw as any[]).map(transformProgramme);

// Debug: Log first programme to verify transformation
// if (typeof window !== 'undefined') {
//     console.log('Sample transformed programme:', PROGRAMMES_DATA[0].program_mer);
// }


import institutionsRaw from '../../../data/institutions.json';
import programmesRaw from '../../../data/programmes.json';

export interface InstitutionRecord {
    inst_code?: string;
    inst_prefix?: string;
    jupas_slug?: string;
    name_eng?: string;
    name_chi?: string;
    forbidden_subject_groups?: string[][];
    urls?: Record<string, string | undefined>;
    grade_values?: Record<string, number>;
    general_mer?: Record<string, unknown>;
    max_subjects_per_category?: { A: number; B: number; C: number };
    max_combined_bc?: number;
    [key: string]: unknown;
}

function parseAnySubjectCount(subjectKey: string): number {
    const match = subjectKey.match(/(\d+)\s+SUBJECT/i);
    return match ? parseInt(match[1], 10) : 1;
}

function parseAnySubjectKeyCategories(anySubjectKey: string): ('A' | 'B' | 'C' | 'core')[] | undefined {
    const upper = anySubjectKey.toUpperCase();
    if (upper.includes('CATEGORY A')) {
        return ['A'];
    }

    const excludeB = upper.includes('APPLIED LEARNING');
    const excludeC = upper.includes('OTHER LANGUAGE');
    if (excludeB && excludeC) {
        return ['A'];
    }
    if (excludeB) {
        return ['A', 'C', 'core'];
    }
    if (excludeC) {
        return ['A', 'B', 'core'];
    }

    return undefined;
}

// Transform function to convert elective_minima to one_of_electives/one_of_groups format
function transformProgramme(prog: any): any {
    if (Array.isArray(prog.program_mer?.elective_alternatives)) {
        return {
            ...prog,
            program_mer: {
                ...prog.program_mer,
                electives: { count: 0, min_level: 3, include_cores: false }
            }
        };
    }

    if (!prog.program_mer?.elective_minima) {
        return prog;
    }
    
    const electives = prog.program_mer.elective_minima;
    const keys = Object.keys(electives);
    
    let anySubjectsCount = 0;
    let anySubjectsMinLevel = 2;
    let anySubjectWildcardCategories: ('A' | 'B' | 'C' | 'core')[] | undefined;
    const anySubjectRequirements: Array<{
        categories: ('A' | 'B' | 'C')[];
        exclude_subjects?: string[];
        requireCount: number;
        min_level: number;
    }> = [];
    const oneOfGroups: Array<{ name?: string; subjects: string[]; min_level: number; requireCount: number }> = [];
    const merCategories = Array.isArray(electives.categories)
        ? electives.categories.filter(
            (category: unknown): category is 'A' | 'B' | 'C' | 'core' =>
                category === 'A' || category === 'B' || category === 'C' || category === 'core',
        )
        : undefined;
    const merExcludedSubjects = Array.isArray(electives.exclude_subjects)
        ? electives.exclude_subjects.filter((subject: unknown): subject is string => typeof subject === 'string')
        : undefined;
    
    for (const key of keys) {
        if (key === 'categories' || key === 'exclude_subjects') continue;

        const electiveReq = electives[key];
        const subjectKeys = Object.keys(electiveReq);
        
        if (subjectKeys.length === 0) continue;
        
        // Check if this key has :one_of or :two_of suffix
        const isTwoOf = key.includes(':two_of');
        const isOneOf = key.includes(':one_of');
        const requireCount = isTwoOf ? 2 : 1;
        
        const anySubjectKey = subjectKeys.find(k => k.toUpperCase().includes('ANY') && k.toUpperCase().includes('SUBJECT'));
        const specificSubjects = subjectKeys.filter(k => k !== anySubjectKey);
        
        if (specificSubjects.length > 0 && (isOneOf || isTwoOf)) {
            const rawLevels = specificSubjects.map(s => electiveReq[s]);
            const numericLevels = rawLevels
                .map(l => (typeof l === 'number' ? l : (typeof l === 'string' && /^\s*\d+\s*$/.test(l) ? Number.parseInt(l, 10) : NaN)))
                .filter(Number.isFinite as any) as number[];
            const commonMinLevel = numericLevels.length > 0 ? Math.min(...numericLevels) : 2;
            const wildcardCount = anySubjectKey ? parseAnySubjectCount(anySubjectKey) : 0;
            const specificRequireCount = anySubjectKey
                ? Math.max(0, requireCount - wildcardCount)
                : requireCount;

            // In MER data, patterns like:
            //   "two_of: <pool> + ANY 1 SUBJECT"
            // mean one slot must come from the explicit pool and one slot can be
            // satisfied by any subject. The wildcard consumes part of the total
            // required count instead of adding an extra elective.
            if (specificRequireCount > 0) {
                oneOfGroups.push({
                    name: specificRequireCount === 2 ? `Two of the following` : `One of the following`,
                    subjects: specificSubjects,
                    min_level: commonMinLevel,
                    requireCount: specificRequireCount
                });
            }

            if (anySubjectKey) {
                const wildcardCategories = parseAnySubjectKeyCategories(anySubjectKey);
                anySubjectsCount += wildcardCount;
                anySubjectsMinLevel = electiveReq[anySubjectKey];
                anySubjectWildcardCategories = wildcardCategories || anySubjectWildcardCategories;
                anySubjectRequirements.push({
                    categories: (merCategories || wildcardCategories || ['A', 'B', 'C'])
                        .filter((category: 'A' | 'B' | 'C' | 'core'): category is 'A' | 'B' | 'C' => category !== 'core'),
                    ...(merExcludedSubjects?.length ? { exclude_subjects: merExcludedSubjects } : {}),
                    requireCount: wildcardCount,
                    min_level: electiveReq[anySubjectKey],
                });
            }
        } else if (anySubjectKey && specificSubjects.length === 0) {
            const wildcardCategories = parseAnySubjectKeyCategories(anySubjectKey);
            const wildcardCount = parseAnySubjectCount(anySubjectKey);
            anySubjectsCount += wildcardCount;
            anySubjectsMinLevel = electiveReq[anySubjectKey];
            anySubjectWildcardCategories = wildcardCategories || anySubjectWildcardCategories;
            anySubjectRequirements.push({
                categories: (merCategories || wildcardCategories || ['A', 'B', 'C'])
                    .filter((category: 'A' | 'B' | 'C' | 'core'): category is 'A' | 'B' | 'C' => category !== 'core'),
                ...(merExcludedSubjects?.length ? { exclude_subjects: merExcludedSubjects } : {}),
                requireCount: wildcardCount,
                min_level: electiveReq[anySubjectKey],
            });
        } else if (specificSubjects.length > 0) {
            const rawLevels = specificSubjects.map(s => electiveReq[s]);
            const numericLevels = rawLevels
                .map(l => (typeof l === 'number' ? l : (typeof l === 'string' && /^\s*\d+\s*$/.test(l) ? Number.parseInt(l, 10) : NaN)))
                .filter(Number.isFinite as any) as number[];
            const commonMinLevel = numericLevels.length > 0 ? Math.min(...numericLevels) : 2;
            
            oneOfGroups.push({
                name: `One of the following`,
                subjects: specificSubjects,
                min_level: commonMinLevel,
                requireCount: 1
            });
        }
    }
    
    // Build transformed program_mer
    const transformedMER: any = {
        ...prog.program_mer,
        electives: {
            count: anySubjectsCount + oneOfGroups.length,
            min_level: anySubjectsMinLevel,
            include_cores: false
        }
    };

    if (anySubjectRequirements.length > 0 && oneOfGroups.length === 0) {
        transformedMER.elective_requirements = anySubjectRequirements;
    }
    
    // Add one_of_groups if there are specific subject requirements
    if (oneOfGroups.length === 1) {
        // Single group - use one_of_electives for simpler display
        transformedMER.one_of_electives = {
            subjects: oneOfGroups[0].subjects,
            min_level: oneOfGroups[0].min_level,
            requireCount: oneOfGroups[0].requireCount
        };
    } else if (oneOfGroups.length > 1) {
        // Multiple groups - use one_of_groups
        transformedMER.one_of_groups = oneOfGroups;
    }
    
    // Add additional_any_one_subject or additional_any_two_subjects if there are both
    // "ANY X SUBJECT" and specific subject requirements
    if (anySubjectsCount > 0 && oneOfGroups.length > 0) {
        const rawAdditionalCategories = merCategories?.length
            ? merCategories
            : anySubjectWildcardCategories;
        const additionalCategories = rawAdditionalCategories?.filter(
            (category: 'A' | 'B' | 'C' | 'core') => category !== 'core',
        );

        if (anySubjectsCount === 1) {
            transformedMER.additional_any_one_subject = {
                min_level: anySubjectsMinLevel,
                ...(additionalCategories?.length ? { categories: additionalCategories } : {}),
            };
        } else if (anySubjectsCount === 2) {
            transformedMER.additional_any_two_subjects = {
                min_level: anySubjectsMinLevel,
                ...(additionalCategories?.length ? { categories: additionalCategories } : {}),
            };
        }
    }
    
    return {
        ...prog,
        program_mer: transformedMER
    };
}

export const INSTITUTIONS_DATA: Record<string, InstitutionRecord> =
    institutionsRaw as Record<string, InstitutionRecord>;

// Deduplicate by jupas_id (keep first occurrence) to avoid React key conflicts
const _seenIds = new Set<string>();
export const PROGRAMMES_DATA = (programmesRaw as any[])
    .filter(p => {
        if (_seenIds.has(p.jupas_id)) return false;
        _seenIds.add(p.jupas_id);
        return true;
    })
    .map(transformProgramme);
